import { FC, ReactNode } from 'react';

import { Box, Flex, forwardRef, rem, StyleProps } from '@bonusly/design-system';

interface CountBadgeProps extends StyleProps {
	children?: ReactNode;
	count?: number | string;
	size?: number | string;
}

export const CountBadge: FC<CountBadgeProps> = forwardRef(({ children, count, size = rem(18), ...rest }, ref) => (
	<Box display="inline-block" position="relative" ref={ref}>
		{children}
		{count !== undefined && (
			<Flex
				alignItems="center"
				bg="red.500"
				border="none"
				borderRadius="full"
				bottom="auto"
				color="white"
				fontSize="xs"
				fontWeight="semibold"
				h={size}
				justifyContent="center"
				position="absolute"
				right={rem(-4)}
				top={rem(-4)}
				w={size}
				{...rest}
			>
				{count}
			</Flex>
		)}
	</Box>
));
